import {useEffect, useState} from 'react';

export function useIsMobile(MOBILE_BREAKPOINT = 700): boolean {
  const query = `(max-width: ${MOBILE_BREAKPOINT}px)`;
  const hasMatchMedia =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function';

  const [isMobile, setIsMobile] = useState<boolean>(
    hasMatchMedia ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    if (!hasMatchMedia) return;

    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

    const onChange = (): void => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    mql.addEventListener('change', onChange);

    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);

    return (): void => {
      mql.removeEventListener('change', onChange);
    };
  }, [MOBILE_BREAKPOINT, hasMatchMedia]);

  return !!isMobile;
}
